<div class="tab-content">

  <div class="sxl-space-between sxh-heading-button-header">
    <h3 class="">
      {{'metering.group-pane.title' | translate}}{{ (paneType == 'Hot' ? 'metering.group-pane.hot' :
      'metering.group-pane.cold') | translate}}
    </h3>
    <button mat-button class="sx-button sx-button--icon" (click)="addNewGroup()" id="group_add_btn">
      <svg>
        <use xlink:href="#baseline-add-24px" href="#baseline-add-24px" />
      </svg>
      {{'metering.group-pane.create_new' | translate}}
    </button>
  </div>

  <div *ngIf="meteringPointGroupsView.length === 0"> 
    <app-no-content [displayText]="'metering.group-pane.no_groups'|translate"></app-no-content>
  </div>
  
  <article class="sx-alarms-scope sx-metering-point-group" *ngFor="let meteringPointGroup of meteringPointGroupsView; let i=index" id="group_{{i}}">
    <header class="sx-alarms-scope__header" [ngClass]="{ 'sx-metering-point-group__selected': meteringPointGroup.selected }">

      <div [hidden]="meteringPointGroup.selected" class="sx-alarms-scope__section sx-alarms-scope__section--grow">
        <h2 class="sx-metering-point-group__heading">{{meteringPointGroup.name}}</h2>
        <div class="sxh-text-small">{{meteringPointGroup.meteringPoints.length}}
          {{ (meteringPointGroup.meteringPoints.length === 1 ? 'metering.group-pane.metering_point' :
          'metering.group-pane.metering_points') | translate }}</div>
      </div>

      <div [hidden]="!meteringPointGroup.selected" class="sx-metering-scope__input-section sx-metering-scope__input-section--grow">
        <mat-form-field [floatLabel]="'never'" class="sx-metering-scope__input-field">
          <mat-label>Gruppens namn</mat-label>
          <input matInput [(ngModel)]="meteringPointGroup.name" class="" id="field_group_{{i}}_name" />
        </mat-form-field>
      </div>
      <div class="sxl-bar-btn-wrapper" *ngIf="meteringPointGroup.selected">
      
        <div class="sx-alarms-scope__section sx-alarms-scope__section--padless">
          <button mat-button class="sx-metering-scope__button sx-button-full-height" (click)="cancelEditing(meteringPointGroup)" id="group_{{i}}_edit_cancel_btn">
            {{'core.button.cancel' | translate}}
          </button>
        </div>
        <div class="sx-alarms-scope__section sx-alarms-scope__section--padless">
          <button mat-button class="sx-button-full-height sx-metering-point-group__button--magenta" (click)="saveEditing(meteringPointGroup)"  id="group_{{i}}_edit_save_btn"
           [disabled]="meteringPointGroup.name.length === 0 || !unsavedChanges(meteringPointGroup)">
            {{'core.button.save' | translate}}
          </button>
        </div>
      </div>

      <div class="sxl-bar-btn-wrapper" *ngIf="!meteringPointGroup.selected" >
        <div class="sx-alarms-scope__section sx-alarms-scope__section--padless">
          <button mat-button class="sx-metering-scope__button" [disabled]="!meteringPointGroup.id"  id="group_{{i}}_delete_btn" (click)="removeGroup(meteringPointGroup)">
            {{'core.button.delete' | translate}}
            <svg class="sxh-icon-big">
              <use xlink:href="#sx-fel-identifierat" href="#sx-fel-identifierat" />
            </svg>
          </button>
        </div>
        <div class="sx-alarms-scope__section sx-alarms-scope__section--padless">
          <button mat-button class="sx-metering-scope__button" [disabled]="!meteringPointGroup.id"  id="group_{{i}}_edit_btn" [ngClass]="{'mpg-group-button-active': meteringPointGroup.selected && meteringPointGroup.id}"
            (click)="editGroup(meteringPointGroup)">
            {{'core.button.edit' | translate}}
            <svg class="sxh-icon-big">
              <use xlink:href="#sx-installningar" href="#sx-installningar" />
            </svg>
          </button>
        </div>
      </div>

    </header>
    <div *ngIf="meteringPointGroup.selected">
      <div class="sx-metering-point-group__grid">
        <div class="sx-metering-point-group__add" (click)="selectMeteringPoints(meteringPointGroup)">
          <svg>
            <use xlink:href="#baseline-add-24px" href="#baseline-add-24px"></use>
          </svg>
          <div>
            <span class="sxh-capitalize">{{'metering.group-pane.add_metering_point' | translate}}</span>
          </div>
        </div>
        <div *ngFor="let meteringPoint of meteringPointGroup.meteringPoints; let mp=index" class="sx-metering-point-group__point"
          [ngClass]="{'selected': meteringPoint.selected, 'added': meteringPoint.added}" (click)="selectMeteringPointToRemove(meteringPoint)" id="group_{{i}}_mp_{{mp}}">
          <svg>
            <use xlink:href="#sx-fel-identifierat" href="#sx-fel-identifierat" />
          </svg>
          <div>
            <span class="sxh-capitalize">{{meteringPoint.name}} </span>
            <span class="sxh-text-mp-id">({{meteringPoint.id}})</span>
          </div>
        </div>
      </div>
    </div>

  </article>

</div>
